import { LoginAttemptViewModel } from "./UserInfoApi";
import { AjaxService } from "../Helpers/AjaxService";
import { LocalStorageCache, GlobalCacheKeys } from "../Helpers/LocalStorageCache";

export class UserLoginApi {
    private static instance: UserLoginApi;
    static getInstance() { return UserLoginApi.instance || (UserLoginApi.instance = new UserLoginApi()); }

    postUserLogin(username: string, password: string, childSubUser: string): Promise<LoginAttemptViewModel> {
        const ajaxService = AjaxService.getInstance();
        const data = new LoginData(username, password, childSubUser);
        const apiUrl = `/Handlers/AsyncLogin.ashx`;
        return new Promise<LoginAttemptViewModel>((resolve) => {
            LocalStorageCache.getInstance().deletebyGlobalCacheKey(GlobalCacheKeys.User);
            ajaxService.postWithData(apiUrl,
                data,
                (result: LoginAttemptViewModel) => {
                    resolve(result);
                });
        });
    }
    postUserLogOut(): Promise<void> {
        LocalStorageCache.getInstance().deletebyGlobalCacheKey(GlobalCacheKeys.User);
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/admin/public/extranetlogoff.aspx`;
        return new Promise<void>((resolve) => {
            ajaxService.post(apiUrl,
                () => {
                    resolve();
                });
        });
    }
}

class LoginData {
    asyncUsername: string;
    asyncPassword: string;
    childSubUser: string;
    constructor(username: string, password: string, childSubUser: string) {
        //Important not to name them "password" and "username".
        //DW might post to its own login handler and log in.
        this.asyncUsername = username;
        this.asyncPassword = password;
        this.childSubUser = childSubUser;
    }
}